import { LoggingService } from "../../ServiceDesk/sdServices/loggingSvc";
import { AwaEventTracker } from "./awa-event-tracker";
import { LoggingHttpInterceptor } from "./http-interceptor";
import { TelemetryLoggerService } from "./logger-service";
import { TelemetryServiceImplementation } from "./telemetry-service";
import { GlobalTelemetryConstants } from "./telemetry-constants";
import { exceptionHandler } from "./exceptionHandlerDecorator";
import { logLocalStorage } from "./local-storage-logger";
import {
  DefaultServiceDeskProcessor,
  OutgoingRequestProcessingServiceImplementation
} from "./outgoingRequestProcessingService";
import { RequestRetryingService } from "./request-retrying-service";
import { ResourceTimingLoggerService } from "./resource-timing-logger";
import { logSessionStorage } from "./session-storage-logger";
import { TelemetryEventPusher } from "./telemetry-event-pusher";
import { TelemetryTemplateService } from "./telemetry-template-svc";
import { setLoggingService } from "./unhandled-error-wrappers";
import { ServiceDeskConfig } from "../../ServiceDesk/Startup/serviceDeskConfig";
import app from "../../ServiceDesk/sdAppModule";
import sdLoggerModule from "./loggerModule";
import { ApplicationContextFactory } from "../../ServiceDesk/sdServices/context/application-context-factory";

// @ngInject
sdLoggerModule
  .constant("telemetryConstants", new GlobalTelemetryConstants())
  .service("loggerService", TelemetryLoggerService)
  .service("telemetryService", TelemetryServiceImplementation)
  .service("awaEventTracker", AwaEventTracker)
  .service("outgoingRequestProcessingService", OutgoingRequestProcessingServiceImplementation)
  .service("requestRetryingService", RequestRetryingService)
  .service("resourceTimingLoggerService", ResourceTimingLoggerService)
  .service("telemetryEventPusher", TelemetryEventPusher)
  .service("telemetryTemplateService", TelemetryTemplateService)
  .run((loggerService: TelemetryLoggerService, loggingService: LoggingService, awaEventTracker: AwaEventTracker) => {
    awaEventTracker.initialize(loggerService);
    let numberOfOldEvents = awaEventTracker.getNumberOfOldEvents();
    if (numberOfOldEvents) {
      loggingService.logInfo(
        `${numberOfOldEvents} events were not confirmed as sent last session, they will be sent this session instead.`
      );
    }
  })
  .run((telemetryService: TelemetryServiceImplementation) => {
    telemetryService.initializeTimeOnRouteChangeStart();
  })
  .run(logLocalStorage)
  .run(
    (outgoingRequestProcessingService: OutgoingRequestProcessingServiceImplementation, sdConfig: ServiceDeskConfig) => {
      outgoingRequestProcessingService.registerProcessor(new DefaultServiceDeskProcessor(sdConfig.sdBaseUrl));
    }
  )
  .run(logSessionStorage)
  .run((loggingService: LoggingService) => {
    setLoggingService(loggingService);
  })
  .config([
    "$provide",
    function ($provide: ng.auto.IProvideService) {
      $provide.constant("applicationContext", ApplicationContextFactory.create());
    }
  ]);

app
  .config([
    "$provide",
    "$httpProvider",
    function ($provide: ng.auto.IProvideService, $httpProvider: ng.IHttpProvider) {
      $provide.factory("httpInterceptor", [
        "$injector",
        function ($injector: ng.auto.IInjectorService) {
          return $injector.instantiate(LoggingHttpInterceptor);
        }
      ]);
      $httpProvider.interceptors.push("httpInterceptor");
    }
  ])
  .config(exceptionHandler);
